module.exports = __webpack_public_path__ + "img/back.a2ecfad1.svg";